import script from "./cart.vue?vue&type=script&setup=true&lang=js"
export * from "./cart.vue?vue&type=script&setup=true&lang=js"

import "./cart.vue?vue&type=style&index=0&id=7d4ec86a&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4ec86a"]])

export default __exports__